import classnames from 'classnames';
import { QA_FIXTURE_SUMMARY_BLOCK_LEAGUE_TABLE } from '@test-config/testIds';
import { FixtureSummaryBlockLeagueTableComplex as V3FixtureSummaryBlockLeagueTable } from '@stadionhq-v3/football-ui';
import styles from './fixtureSummaryBlockLeagueTable.module.scss';
import { FixtureSummaryBlockLeagueTableProps } from './fixtureSummaryBlockLeagueTable.types';

const FixtureSummaryBlockLeagueTable = ({
  testId = QA_FIXTURE_SUMMARY_BLOCK_LEAGUE_TABLE.COMPONENT,
  classNames = [],
  nativeProps = {},
  ...props
}: FixtureSummaryBlockLeagueTableProps) => {
  const classes = classnames(
    [styles.fixtureSummaryBlockLeagueTable],
    classNames
  );

  return (
    <V3FixtureSummaryBlockLeagueTable
      {...nativeProps}
      classNames={[classes]}
      data-testid={testId}
      {...props}
    />
  );
};

export default FixtureSummaryBlockLeagueTable;
